import { dialogTitleClasses } from "@mui/material";
export const MuiDialogContent = {
    styleOverrides: {
        root: {
            paddingTop: "8px",
            paddingBottom: "8px",
            paddingLeft: "32px",
            paddingRight: "32px",
            // This is required to override MUI paddingTop to 0 when we have title.
            //      Link to MUI open issue about it: https://github.com/mui/material-ui/issues/27851
            [`.${dialogTitleClasses.root} + &`]: {
                paddingTop: "8px"
            },
            ":last-child": {
                paddingBottom: "32px"
            }
        }
    }
};
//# sourceMappingURL=DialogContent.js.map